import { produce } from 'immer'
import { mountStoreDevtool } from 'simple-zustand-devtools'
import { create } from 'zustand'
 
type ApprovalFormState = {
    isFormValid: boolean
    formValues: Record<string, any>
}
 
type ApprovalFormActions = {
    actions: {
        clearFormValues: () => void
        setFormValues: (fieldName: string, value: any) => void
        setFormValidity: (isValid: boolean) => void
    }
}
 
const _initialFormValues = {
    subnetAliases: [
        {
            alias: '',
            count: '',
            identifier: '',
            value: ''
        }
   
    ],
    platformName: '',
    // kms: [
    //     {
    //         delegateAWSAccountIDs: [
               
    //         ],
    //         awsAccountId: '',
    //         roleName: ''
    //     }
    // ],
     delegateAWSAccountIDs: [
               
            ],
     awsAccountId: '',
    roleName: '',
    tfProviders: [
        {
            alias: '',
            region: '',
            arn: '',
            externalId: ''
        }
        // {
        //     alias: 'environment',
        //     region: 'ap-southeast-1',
        //     arn: 'arn:aws:iam::095033845377:role/AC2-IRS-DO-GLD-BL-095033845377-STG',
        //     externalId: 'GitlabRunner-426956141294-095033845377'
        // },
        // {
        //     alias: 'security',
        //     region: 'ap-southeast-1',
        //     arn: 'arn:aws:iam::085094121557:role/AC2-IRS-DO-GLD-SECURITY-STG',
        //     externalId: 'atlas'
        // },
        // {
        //     alias: 'route53',
        //     region: 'ap-southeast-1',
        //     arn: 'arn:aws:iam::095033845377:role/AC2-IRS-DO-GLD-BL-095033845377-STG',
        //     externalId: 'GitlabRunner-426956141294-095033845377'
        // }
    ],
    vpcIdentifier: ' ',
    vpcValue: ' ',
    dnsZoneApex: ' ',
    /** EKS project approval only (see ApprovalForm); stripped on approve for non-EKS */
    workloadClusterName: '',
    workloadClusterVersion: '',
    discoveryTags: null as { label: string; value: string } | null,
    eksCustomNamespaces: [] as string[],
    eksSubApps: [] as Array<{ subAppName: string; targetNamespace: string }>,
    securityAliases: [
        // {
        //     key: 'app',
        //     value: '172.32.0.0/16',
        //     existing: false
        // },
        // {
        //     key: 'bastion',
        //     value: '172.32.0.0/24',
        //     existing: false
        // }
    ],
    tags: [
        // {
        //  key: 'Portfolio',
        //  value: 'mickey',
        //  existing: false
        // },
        // {
        //  key: 'Application',
        //  value: 'mouse',
        //  existing: false
        // }
    ]
 
}
 
const ApprovalFromStore = create<ApprovalFormState & ApprovalFormActions>(
    (set, _get) => ({
        isFormValid: false,
        formValues: _initialFormValues,
        actions: {
            clearFormValues: () => set(() => ({ formValues: _initialFormValues })),
 
            setFormValidity: (isValid) => set(() => ({ isFormValid: isValid })),
 
            setFormValues: (fieldName, value) =>
                set((state) =>
                    produce(state, (draft) => {
                        draft.formValues[fieldName] = value
                    })
                )
        }
    })
)
 
export const useApprovalFormStore = () => ApprovalFromStore((state) => state)
 
if (process.env.NODE_ENV !== 'production') {
    mountStoreDevtool('ApprovalFormStore', ApprovalFromStore)
}